import React, { useRef, useMemo } from 'react';

import { useCurrentUser } from 'Auth';

import BusinessPartnerForm from 'scenes/BusinessPartners/components/BusinessPartnerForm/BusinessPartnerForm';
import {
  useBusinessPartner,
  useUpdateBusinessPartner,
  useCreateBusinessPartner,
} from 'scenes/BusinessPartners/data';

import {
  NAME,
  OWNER,
  PARTNER_COMPANY,
  IO_TYPE,
  INVOICE_PROCESSING_RULE,
} from './constants';
import getEditableFields from './editGranularity';
import { RULE_TYPE, TYPE_KEYWORDS } from './InvoiceProcessingRuleSection';

const GRANULARITY = 'all';

export const BusinessPartnerFormCreate = ({
  partnerCompanies,
  granularity,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const formRef = useRef(null);
  const user = useCurrentUser();
  const [createBusinessPartner, { isLoading }] = useCreateBusinessPartner();

  const editableFields = useMemo(
    () => getEditableFields(granularity || GRANULARITY),
    [granularity]
  );

  const handleSubmit = async (values = {}) => {
    const createdBusinessPartner = await createBusinessPartner(values);

    onSubmit(createdBusinessPartner);
  };

  return (
    <BusinessPartnerForm
      title={'Add Business Partner'}
      loading={isLoading}
      editableFields={editableFields}
      onClose={onClose}
      initialValues={{
        [OWNER]: user.id,
        [IO_TYPE]: 0,
        [PARTNER_COMPANY]: partnerCompanies,
        [INVOICE_PROCESSING_RULE]: {
          [RULE_TYPE]: TYPE_KEYWORDS,
        },
      }}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      isShowPartnerBusinessPartner={true}
      ref={formRef}
    />
  );
};

export const BusinessPartnerFormEdit = ({
  id,
  granularity,
  onClose,
  onSubmit,
  onExited,
  open,
}) => {
  const formRef = useRef(null);
  const { data, isLoading: loading } = useBusinessPartner({ id });
  const [updateBusinessPartner, { isLoading }] = useUpdateBusinessPartner();

  const editableFields = useMemo(
    () => getEditableFields(granularity || GRANULARITY),
    [granularity]
  );

  const handleSubmit = async (values) => {
    const response = await updateBusinessPartner(values);
    onSubmit(response);
  };

  return (
    <BusinessPartnerForm
      title={'Edit Business Partner'}
      subTitle={data?.[NAME]}
      entityId={id}
      loading={loading || isLoading}
      editableFields={editableFields}
      onClose={onClose}
      initialValues={data}
      active={!!data}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      isShowPartnerBusinessPartner={false}
      isEdit={true}
      ref={formRef}
    />
  );
};
